import { useEffect, useRef, useState } from 'react'
// import { errorHandle } from '../../api/api'
import { getUserInfo } from '../../classes/User'
import { useUserContext } from '../../context/userContext'
import ProfileDetail from './ProfileDetail'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'
import { useToast } from '@chakra-ui/react'

const ProfileInfo = () => {
    const toast = useToast()
    const { userData } = useUserContext()
    const [data, setData] = useState(null)
    const loadData = useRef()

    loadData.current = async () => {
        await getUserInfo(userData.id, userData.token)
            .then(res => {
                setData(res)
            })
            .catch(error => {
                // console.log('error')
                // console.log(errorHandle(error))
                toast(toastVal({
                    title: "การดึงข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })

    }

    useEffect(() => {
        loadData.current()
    }, [])

    return (
        data && <ProfileDetail data={data} />
    )
}

export default ProfileInfo
